<template>
  <div class="w-full mb-4">

    <img :src="imgUrl" class="w-full rounded" alt=""/>

    <div @click="emit('delete-image-on-index')" class="mt-2">
      delete
    </div>

  </div>
</template>

<script setup>
import {isBase64} from "@/helpers/General.js";
import {IMG_URL} from "@/content/lists.js";
import {computed} from "vue";

const props = defineProps({
  img: {
    required: true
  }
})

const emit = defineEmits(['delete-image-on-index'])

const imgIsBase64 = isBase64(props.img)

const imgUrl = computed(() => imgIsBase64 ? props.img : `${IMG_URL}/public/app-products-images/${props.img}`)

</script>